export default __webpack_public_path__ + "static/media/EUR.e280005a.svg";